import type { IconData } from '@stacksjs/iconify-core'

export const devicesHeadphones: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 8a8 8 0 1 1 16 0v8H9.5V8H13A5 5 0 1 0 3 8h3.5v8H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesHeadphones
